export const BASE_API_URL = 'https://holidaze-backend.herokuapp.com';
